import React from 'react';
import styled from 'styled-components';
import { FootnoteMarker } from 'packages/smart-home-support/components';
import CalculatorSelectionItem from './CalculatorSelectionItem';
import { deviceNameSort } from '../../utils';
import { CalculatorSelectionProps, AddDevicesProps } from '../../models';
import BREAK_POINTS from '../../../../styling/media-queries';
import ContainerColumn from './ContainerColumn';

const DeviceCell = styled.div<AddDevicesProps>`
  display: flex;
  justify-content: center;
  width: ${(props) => (props.allowTwoColumns && 50) || 33}%;
  @media ${BREAK_POINTS.mobileBig} {
    width: 33%;
  }
  @media ${BREAK_POINTS.tabletBig} {
    width: 20%;
  }
`;

const SelectionColumn = styled(ContainerColumn)<{ useMobileMargin?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  width: 100%;
  margin-top: ${(props) => (props.useMobileMargin ? 45 : 0)}px;
  margin-bottom: ${(props) => (props.useMobileMargin ? 30 : 0)}px;
  padding: 0 15px;
  box-sizing: border-box;
  @media ${BREAK_POINTS.mobileBig} {
    margin-bottom: 70px;
  }
  @media ${BREAK_POINTS.desktop} {
    justify-content: space-between;
    max-width: 675px;
    margin-top: 0;
    margin-bottom: 0;
    flex-shrink: 0;
  }
`;

const DisclaimersContainer = styled.div`
  margin-top: 20px;
  margin-left: 5px;
  margin-right: 5px;
`;

const Disclaimer = styled.div`
  text-align: left;
  font-size: 14px;
`;

const CalculatorSelection: React.FunctionComponent<CalculatorSelectionProps> = (props) => {
  const { devices, deviceQuantities, onChangeDeviceQuantities, allowTwoColumns } = props;
  const deviceDisclaimers = props.deviceDisclaimers || {};
  const sortedDeviceNames: string[] = deviceNameSort(devices);

  const disclaimers = [...Array.from(new Set(Object.values(deviceDisclaimers)))];

  return (
    <SelectionColumn useMobileMargin={!allowTwoColumns}>
      {sortedDeviceNames.map((deviceName) => (
        <DeviceCell key={deviceName} allowTwoColumns={props.allowTwoColumns}>
          <CalculatorSelectionItem
            device={devices[deviceName]}
            deviceName={deviceName}
            onChangeDeviceQuantities={onChangeDeviceQuantities}
            deviceQuantities={deviceQuantities}
            hasDisclaimer={Boolean(deviceDisclaimers[deviceName])}
            allowTwoColumns={allowTwoColumns}
          />
        </DeviceCell>
      ))}
      <DisclaimersContainer>
        {disclaimers.map((disclaimer, i) => (
          <Disclaimer key={i}>
            <FootnoteMarker />
            {disclaimer}
          </Disclaimer>
        ))}
      </DisclaimersContainer>
    </SelectionColumn>
  );
};

export default CalculatorSelection;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/selection/components/CalculatorSelection.tsx